import { IndividualExamStatusDto } from '@/api/generated';

import { ExamineeExamTranslation } from './examineeExam.translation.en';

export const examineeExamTranslation: ExamineeExamTranslation = {
  areaScopeLabel: 'Zakres',
  areasIntro:
    'Poniżej widzisz obszary egzaminu. Pod każdym obszarem jest lista podkategorii — to jest to, na co komisja zwraca uwagę i o czym warto opowiedzieć. Punktacji nie widzisz w trakcie egzaminu, a wynik (zaliczony / niezaliczony) zobaczysz dopiero po zakończeniu egzaminu.',
  areaStatusFailed: 'NIEZALICZONY',
  areaStatusOpen: 'W TRAKCIE',
  areaStatusPassed: 'ZALICZONY',
  back: 'Wróć do moich certyfikacji',
  carriedOverPassedOn: 'Zaliczono {{date}}',
  carriedOverSubtitle:
    'Te obszary zaliczyłeś w jednym z wcześniejszych terminów tego etapu i są przeniesione jako zaliczone — nie musisz podchodzić do nich ponownie.',
  carriedOverTitle: 'Zaliczone w poprzednim terminie',
  commentUpdatedAt: 'Aktualizacja {{date}}',
  commissionCommentsTitle: 'Komentarze komisji',
  commissionEvaluating: 'Komisja Cię ocenia',
  drawnReportLabel: 'Wylosowany raport dla Ciebie',
  examLabel: 'Egzamin',
  examName: 'Certyfikacja praktyczna',
  finishedNoCommentsInfo: 'Komisja nie zostawiła żadnych ogólnych komentarzy do tego egzaminu.',
  loadError: 'Nie udało się załadować widoku egzaminu.',
  noAttachments: 'Brak załączników do podglądu.',
  noSharedReports: 'Komisja nie udostępniła jeszcze żadnego raportu. Zaczekaj.',
  notStartedInfo:
    'Egzamin nie jest w trakcie. Raporty będą widoczne po rozpoczęciu egzaminu przez komisję.',
  pdfPreviewError: 'Nie udało się załadować podglądu PDF.',
  pdfPreviewLoading: 'Ładowanie podglądu PDF…',
  pdfPreviewPager: 'Strona {{page}} z {{total}}',
  reportFallbackTitle: 'Raport',
  reportNotSharedYet: 'Komisja udostępni Ci ten raport do analizy w trakcie egzaminu.',
  reportPreviewOnlyInProgress: 'Podgląd raportu jest dostępny tylko w trakcie trwania egzaminu.',
  reportQuestionsTitle: 'Pytania do raportu',
  roleChairman: 'Przewodniczący komisji',
  roleHrbp: 'HRBP',
  sharedAt: 'Udostępniono {{date}}',
  startedAt: 'Rozpoczęto {{date}}',
  status: {
    [IndividualExamStatusDto.Cancelled]: 'Anulowany',
    [IndividualExamStatusDto.Draft]: 'Wersja robocza',
    [IndividualExamStatusDto.Failed]: 'Niezaliczony',
    [IndividualExamStatusDto.Passed]: 'Zaliczony',
    [IndividualExamStatusDto.Started]: 'W trakcie',
  },
  statusHeaderLabel: 'Status',
  subcategoryGraded: 'Ocenione',
  subcategoryNotGraded: 'Jeszcze nie ocenione',
  subquestionsTitle: 'Podpytania',
  title: 'Egzamin praktyczny',
};
